import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { VertNavButtonsWrapper, Wrapper, NavBarToggle, } from '../vertical_icon_bar/vertical_icon_bar.styles';
import { IconButton } from '../buttons';
import theme from '../../styles/theme';
export const VerticalNavIconBar = props => {
    const { expanded, toggleNavBar, children } = props;
    const navBarIconName = expanded ? 'CloseCaretIconOffCenter' : 'OpenCaretIconOffCenter';
    const showToggle = typeof toggleNavBar === 'function';
    return (_jsx(Wrapper, { expanded: expanded, children: _jsxs(VertNavButtonsWrapper, { "data-testid": props['data-testid'], expanded: expanded, children: [showToggle && (_jsx(NavBarToggle, { expanded: expanded, children: _jsx(IconButton, { iconName: navBarIconName, onClick: toggleNavBar, label: "Toggle expanded side nav", style: {
                            width: '30px',
                            height: '30px',
                            background: theme.colors.blue80,
                        }, fill: "white" }) })), children] }) }));
};
//# sourceMappingURL=vertical_nav_icon_bar.js.map